import React from "react";
import { addDays, format } from "date-fns";
import { fr } from "date-fns/locale";
import DateLine from "./DateLine";
import { IJ_YEAR, dailyAllowance } from "./congeRules";

// "lundi 1er février 2027": French writes the first of the month as an ordinal.
const long = (date) => format(date, "EEEE d MMMM yyyy", { locale: fr }).replace(/^(\S+) 1 /, "$1 1er ");
const euros = (n) => n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
const weeks = (n) => `${n} semaine${n > 1 ? "s" : ""}`;

export default function CongesMaternite({ leave, salary }) {
    if (!leave) {
        return (
            <p className="text-white text-sm text-center py-6">
                Saisissez une date pour afficher les dates de votre congé maternité.
            </p>
        );
    }

    const ij = dailyAllowance(salary);

    return (
        <div className="text-white">
            <p className="text-sm">{leave.label}</p>
            <p className="text-lg sm:text-xl font-bold mb-3">
                {weeks(leave.totalWeeks)} de congé maternité
            </p>

            <p className="font-semibold text-sm mb-1">Congé prénatal · {weeks(leave.preWeeks)}</p>
            <DateLine description="Début du congé" date={long(leave.start)} />

            <p className="font-semibold text-sm mt-3 mb-1">Naissance</p>
            <DateLine description="Date prévue d'accouchement" date={long(leave.dueDate)} />

            <p className="font-semibold text-sm mt-3 mb-1">Congé postnatal · {weeks(leave.postWeeks)}</p>
            <DateLine description="Fin du congé" date={long(leave.end)} />

            {(leave.pathoPre || leave.pathoPost) && (
                <>
                    <p className="font-semibold text-sm mt-3 mb-1">Congé pathologique</p>
                    {leave.pathoPre && (
                        <DateLine description="Prénatal (2 semaines)" date={format(leave.pathoPre.start, "dd/MM/yyyy")} endDate={format(leave.pathoPre.end, "dd/MM/yyyy")} />
                    )}
                    {leave.pathoPost && (
                        <DateLine description="Postnatal (4 semaines max.)" date={format(leave.pathoPost.start, "dd/MM/yyyy")} endDate={format(leave.pathoPost.end, "dd/MM/yyyy")} />
                    )}
                </>
            )}

            <DateLine description="Reprise du travail" date={long(addDays(leave.pathoPost ? leave.pathoPost.end : leave.end, 1))} />

            {ij > 0 && (
                <>
                    <p className="font-semibold text-sm mt-3 mb-1">Indemnités journalières estimées ({IJ_YEAR})</p>
                    <DateLine description="Par jour (net de CSG-CRDS)" date={euros(ij)} />
                    <DateLine description={`Sur ${leave.days} jours de congé`} date={euros(ij * leave.days)} />
                    <p className="text-xs opacity-80 mt-1">
                        Estimation versée par l'Assurance Maladie, sous conditions d'ouverture de droits. Votre employeur peut maintenir tout ou partie du salaire selon votre convention collective.
                    </p>
                </>
            )}

            <p className="text-xs opacity-80 mt-4">
                Si l'accouchement a lieu avant la date prévue, la partie du congé prénatal non prise s'ajoute au congé postnatal. S'il a lieu après, le congé prénatal se prolonge jusqu'à la naissance sans réduire le congé postnatal. Depuis le 1er juillet 2026, un congé supplémentaire de naissance de 1 à 2 mois peut suivre le congé maternité.
            </p>
        </div>
    );
}
